import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);

  const breadcrumbMap = {
    'role-based-dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    'student-profile-management': { label: 'Profile Management', icon: 'UserCircle' },
    'job-search-application': { label: 'Job Search', icon: 'Search' },
    'job-posting': { label: 'Post Job', icon: 'PlusCircle' },
    'candidate-management': { label: 'Candidates', icon: 'Users' },
    'institution-management': { label: 'Institutions', icon: 'Building2' },
    'admin-controls': { label: 'Admin Controls', icon: 'Shield' },
    'analytics': { label: 'Analytics', icon: 'BarChart3' },
    'notifications': { label: 'Notifications', icon: 'Bell' },
    'support': { label: 'Support', icon: 'HelpCircle' }
  };

  const routeLabels = {
    '/': 'Home',
    '/role-based-dashboard': 'Dashboard',
    '/job-search-application': 'Job Search',
    '/student-profile-management': 'Profile Management',
    '/job-posting': 'Job Posting',
    '/employer-registration-profile': 'Employer Profile',
    '/candidate-management': 'Candidate Management',
    '/institution-management-portal': 'Institution Management',
    '/analytics': 'Analytics',
    '/admin-controls': 'Admin Controls'
  };

  const breadcrumbs = pathSegments?.map((segment, index) => {
    const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
    const config = breadcrumbMap?.[segment] || { 
      label: segment?.replace(/-/g, ' '), 
      icon: 'FileText' 
    };
    return { path, ...config };
  });

  if (breadcrumbs?.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <div className="bg-card border border-border rounded-lg px-4 py-3 shadow-sm">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          <li>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 px-3 py-1.5 text-muted-foreground hover:text-primary hover:bg-primary/5 rounded-md transition-smooth group"
            >
              <Icon name="Home" size={16} className="group-hover:scale-110 transition-transform" />
              <span className="hidden sm:inline font-medium">Home</span>
            </button>
          </li>
          {breadcrumbs?.map((crumb, index) => (
            <li key={crumb?.path} className="flex items-center gap-2">
              <Icon name="ChevronRight" size={16} color="var(--color-muted-foreground)" />
              {index === breadcrumbs?.length - 1 ? (
                <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-md">
                  <Icon name={crumb?.icon} size={16} />
                  <span className="font-semibold capitalize">
                    {crumb?.label}
                  </span>
                </div>
              ) : (
                <button
                  onClick={() => navigate(crumb?.path)}
                  className="flex items-center gap-2 px-3 py-1.5 text-muted-foreground hover:text-primary hover:bg-primary/5 rounded-md transition-smooth group capitalize"
                >
                  <Icon name={crumb?.icon} size={16} className="group-hover:scale-110 transition-transform" />
                  <span className="font-medium">{crumb?.label}</span>
                </button>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;